import { Typography } from '@mui/material';
import { useField } from 'formik';
import { IdentificationCard } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import { Spacer } from 'theSource/components';
import {
  FileFieldStyled,
  IdCardAddUploadWrapperStyled,
  IdCardUploadButtonStyled,
  LabelStyled,
  LabelWrapperStyled,
  PlaceholderWrapperStyled,
} from './IdCardAddUploadStyled';
import { TEN_MEGS, VALID_IMAGE_MIME_TYPES } from './utils';
import { ImageStyled } from 'theSource/features/IdCards/components';

interface IdCardAddButtonProps {
  id: string;
  label?: string;
  imgSrc?: string;
  alt?: string;
  onUpload: (name: string, url: string) => void;
  required?: boolean;
  testId?: string;
}

export const IdCardAddUpload = ({
  id,
  label,
  imgSrc,
  alt,
  onUpload,
  required = false,
  testId = 'id-card-add-upload',
}: IdCardAddButtonProps) => {
  const { t } = useTranslation('pages.idCards');

  const { error, touched } = useField({
    name: id,
  })[1];

  return (
    <IdCardAddUploadWrapperStyled data-testid={testId}>
      <IdCardUploadButtonStyled $error={touched && Boolean(error)}>
        <LabelStyled htmlFor={id}>
          {imgSrc ? (
            <PlaceholderWrapperStyled>
              <ImageStyled src={imgSrc} alt={alt} />
            </PlaceholderWrapperStyled>
          ) : (
            <>
              <LabelWrapperStyled>
                <Typography variant="label">{`${label}${
                  required ? '*' : ''
                }`}</Typography>
              </LabelWrapperStyled>
              <IdentificationCard size={48} weight="duotone" />
              <Spacer height={3} />
              <Typography variant="caption">{t('uploadCard')}</Typography>
            </>
          )}
        </LabelStyled>
      </IdCardUploadButtonStyled>
      <FileFieldStyled
        label={id}
        testId={`${testId}-input`}
        id={id}
        name={id}
        maxSize={TEN_MEGS}
        accept={VALID_IMAGE_MIME_TYPES}
        onUpload={onUpload}
      />
    </IdCardAddUploadWrapperStyled>
  );
};
